import "../scss/main.scss";

(function ($) {
  $(document).ready(function () {
    theme.init();
  });

  var theme = {
    init: function () {
      this.headerFunctions();
      this.runSliders();
      this.animations();
    },

    headerFunctions: function () {
      // mobile menu toggle
      $(".toggle-nav").click(function (e) {
        e.preventDefault();
        $("body").toggleClass("fixed");
        $(this).find('.icon-bar').toggleClass("toggled");
        $(".main-menu-container").toggleClass("opened");
      });

      // sticky header
      $(window).scroll(function () {
        var scroll = $(window).scrollTop();

        if (scroll >= 300) $("header.navbar").addClass("fixed");
        else $("header.navbar").removeClass("fixed");
      });
    },

    runSliders: function () {
      $(".hero-slider").on("init", function (event, slick) {
        $(".hero-slider .slick-current").addClass("animated");
      });

      $(".hero-slider").on(
        "afterChange",
        function (event, slick, currentSlide, nextSlide) {
          $(".hero-slider .slide").removeClass("animated");
          $(".hero-slider .slick-active").addClass("animated");
        }
      );

      $(".hero-slider").slick({
        arrows: true,
        dots: false,
        fade: true,
        prevArrow: "<span class='slick-arrow slick-prev'></span>",
        nextArrow: "<span class='slick-arrow slick-next'></span>",
        autoplay: true,
        infinite: true,
        autoplaySpeed: 5000,
        speed: 800,
        cssEase: 'linear'
      });

      $('.testimonials-slider').slick({
        prevArrow: "<span class='slick-arrow slick-prev'></span>",
        nextArrow: "<span class='slick-arrow slick-next'></span>",
        autoplay: true,
        infinite: true,
        autoplaySpeed: 5000,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              arrows: false,
              dots: true
            }
          }
        ]
      });

      $(".hero-slider, .testimonials-slider").each(function () {
        $(this)
          .find(".slick-arrow")
          .wrapAll('<div class="slider-nav"></div>');
      });
    },

    animations: function () {
      // on viewport animations
      function isInViewport(node) {
        var rect = node.getBoundingClientRect();
        return (
          (rect.height > 0 || rect.width > 0) &&
          rect.bottom >= 0 &&
          rect.right >= 0 &&
          rect.top <=
            (window.innerHeight || document.documentElement.clientHeight) &&
          rect.left <=
            (window.innerWidth || document.documentElement.clientWidth)
        );
      }
      function animations() {
        $(".animated").each(
          function () {
            if (isInViewport(this)) {
              $(this).addClass("inViewport");
            }
          }
        );
      }

      animations();

      $(window).scroll(function () {
        animations();
      });
    },
  };
})(jQuery);
